import { SvgIconNames } from '@design';

export const getEarningsInsightIconName = (
  isPreview: boolean,
  isBordered: boolean
): SvgIconNames => {
  if (isPreview) {
    return isBordered ? 'EarningsPreview' : 'EarningsPreviewBorderless';
  }

  return isBordered ? 'EarningsRecap' : 'EarningsRecapBorderless';
};
